import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";

import { CellComponentProps } from "../types";

type UserIdpGroupsListItemNameCellProps = CellComponentProps;

const UserIdpGroupsListItemNameCell = ({
  name,
  mappedGroup,
}: UserIdpGroupsListItemNameCellProps) => {
  return mappedGroup ? (
    <Link
      analyticsPage={AnalyticsPageOrganization.OrganizationUserIdpGroups}
      analyticsTitle="Group Name Clicked"
      analyticsProps={{
        groupName: name,
      }}
      size="small"
      variant="secondary"
      href={`/settings/idp-group/${mappedGroup?.id}`}
    >
      {name}
    </Link>
  ) : (
    <TextEllipsis
      tooltip={`${name} group is not mapped to any IdP group. You can do it in the IdP group mapping.`}
      forceTooltipActive={true}
      tooltipWidthMode="maxWidthSm"
    >
      {(props) => (
        <Typography {...props} tag="p" variant="p-body3" color="secondary">
          {name}
        </Typography>
      )}
    </TextEllipsis>
  );
};

export default UserIdpGroupsListItemNameCell;
